<template>
  <span class="inline-flex items-center gap-2">
    <span class="relative flex h-2.5 w-2.5 flex-shrink-0">
      <span
        v-if="active"
        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60"
      ></span>
      <span
        class="relative inline-flex h-2.5 w-2.5 rounded-full transition-colors duration-300"
        :class="active ? 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.7)]' : 'bg-gray-600'"
      ></span>
    </span>
    <span
      v-if="label"
      class="text-xs font-medium transition-colors duration-300"
      :class="active ? 'text-emerald-400' : 'text-gray-500'"
    >{{ label }}</span>
  </span>
</template>

<script setup>
defineProps({
  active: { type: Boolean, required: true },
  label: { type: String, default: '' },
});
</script>
